export const periodFields = `
  id
  name
  dateFrom  
  dateTo
  type
  wab {
    filename
    uploader
    identityId
  }
  description
`;